export default {
  init() {
    // JavaScript to be fired on all pages
    $(window).load(function () { // makes sure the whole site is loaded
      $('#status').fadeOut(); // will first fade out the loading animation
      $('#preloader').delay(350).fadeOut('slow'); // will fade out the white DIV that covers the website.
      $('body').delay(350).css({ 'overflow': 'visible' });
    });
    //lazy load
    $('.lazy').Lazy({
      // your configuration goes here
      effect: 'fadeIn',
      visibleOnly: true,
    });

    //scroll  
    var menu = $('.top-menu-container');
    var h = menu.outerHeight();
    $(window).scroll(function () {
      var distance = $(window).scrollTop();
      //console.log(distance);
      if (distance > h) {
        $('#scroll-top').fadeIn();
        $(menu).find('button.hamburger').addClass('scroll-hamburger');
      } else {
        $('#scroll-top').fadeOut();
        $(menu).find('button.hamburger').removeClass('scroll-hamburger');
      }
    });

    //hamburger menu select 
    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      $(this).parent().parent().toggleClass('is-active-selectore');
      $('#hamburger-menu-container').toggleClass('is-open-menu');
    });

    //outside menu


    const $menu = $('.top-menu-container');

    $(document).mouseup(e => {
      if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
        $('#hamburger-menu-container').removeClass('is-open-menu');
        $('#select-hamburger-container').removeClass('is-active-selectore');
        $('#select-hamburger-container .hamburger').removeClass('is-active');
      }
    });




    //hamburger menu mobile
    if ($(window).width() < 768) {
      hamburgerSubMenu();
    }

    function hamburgerSubMenu() {
      $('#hamburger-menu-container .menu-item-has-children  > a').click(function (event) {
        event.preventDefault();
        var t = $(this);
        var subMenu = $(this).parent().find('.sub-menu');
        $('#hamburger-menu-container .menu-item-has-children .sub-menu').slideUp();
        if ($(subMenu).is(':visible')) {
          $(subMenu).slideUp();
        } else {
          $(subMenu).slideDown();
        }
        $('#hamburger-menu-container .menu-item-has-children  > a').each(function () {
          if ($(this) != t) {
            $(this).addClass('cover!');
          }
        })
      });
    }

    //load more
    $('.image-loader').hide();
    $('#pagination a.page-numbers').addClass('item-load').text('ALTRI PRODOTTI');
    $('#pagination a.page-numbers.next').remove();
    $('#pagination').on('click', 'a.item-load', function (e) {
      e.preventDefault();
      if ($(this).next('a')[0]) {
        $(this).hide()
        $(this).next().show();
      } else {
        $(this).removeClass('item-load').hide();
      }
      var link = $(this).attr('href');
      $('#image-loader').show();
      $('#content-load-more').load(link + ' #content-post > .row > div', function (responseTxt, statusTxt, xhr) {
        if (statusTxt == 'success')
          var txt = $('#content-load-more').html();
        $('#content-post > .row').append(txt).hide().fadeIn();
        $('.image-loader').hide();
        if (statusTxt == 'error')
          console.log('Error: ' + xhr.status + ':' + xhr.statusText);
      });
    })

    //scroll top
    $('#scroll-top').click(function (event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: 0,
      }, 500);
    });
    //video
    $('#modal-video').on('hidden.bs.modal', function () {
      $(this).find('iframe').attr('src','');
    });
    $('#modal-video').on('show.bs.modal', function () {
      var url = $(this).attr('data-src');
      $(this).find('iframe').attr('src',url);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js